<section class="section">
    <div class="container">
        <div class="section-header center">
            <div class="header-start">
                <h2 class="title"> Rapid Development <br> No-Code Solutions for Faster Time-to-Market
                </h2>
            </div>
        </div>

        <div class="row g-3 g-xl-5">
            <ng-container *ngFor="let item of items">
                <div class="col-sm-6 col-xl-4">
                    <div class="card h-100">
                        <div class="card-body">
                            <div class="icon">
                                <i class="mdi" [class]="item.icon"></i>
                            </div>
                            <h2 class="card-title">{{item.title}}</h2>
                            <p>{{item.description}}</p>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</section>